import { createContext, useContext, useState } from "react";

const dict = {
  it: {
    nav_home: "Home", nav_tests: "Test", nav_guides: "Guide", nav_pricing: "Prezzi",
    nav_dashboard: "Dashboard", nav_login: "Accedi", nav_logout: "Esci",
    nav_register: "Registrati",
    hero_kicker: "EPSO 2026 — Nuovo format",
    hero_title: "Supera il test EPSO.",
    hero_title2: "Con metodo. Con rigore.",
    hero_sub: "Allenati sui tre test di ragionamento (verbale, astratto, numerico) con domande originali e un test gratuito subito disponibile. Le guide premium spiegano come pensare — non come indovinare.",
    hero_cta1: "Inizia il test gratuito",
    hero_cta2: "Vedi i prezzi",
    hero_badge1: "Domande originali",
    hero_badge2: "GDPR compliant",
    hero_badge3: "Freemium",
    how_kicker: "Come funziona",
    how_title: "Tre passi. Zero perdite di tempo.",
    how1_t: "Prova gratis, senza account",
    how1_p: "12 domande per tipo (verbale, astratto, numerico) — vedi subito il tuo livello.",
    how2_t: "Sblocca i pacchetti",
    how2_p: "Test premium per categoria oppure il bundle completo.",
    how3_t: "Leggi le guide premium",
    how3_p: "Metodo passo-passo, protetto e non scaricabile, per ogni test.",
    pricing_kicker: "Prezzi trasparenti",
    pricing_title: "Paga solo ciò che ti serve",
    pricing_sub: "Nessun abbonamento. Nessuna sorpresa.",
    footer_note: "EU Logic Lab non è affiliata con EPSO o le istituzioni UE. Le domande sono elaborate in modo originale a fini di allenamento.",
    cookie_msg: "Usiamo cookie tecnici essenziali per il servizio e, previo consenso, cookie di marketing/pubblicità (Google Ads) per misurare le conversioni. Leggi la",
    cookie_link: "cookie policy",
    cookie_accept: "Accetta tutti",
    cookie_reject: "Solo essenziali",
    accept_terms: "Accetto la privacy policy e i termini di servizio (obbligatorio ai sensi del GDPR)",
    email: "Email", password: "Password", name: "Nome",
    login_title: "Accedi al tuo account",
    register_title: "Crea il tuo account",
    already_have: "Hai già un account?", need_account: "Nuovo qui?",
    or_google: "oppure",
    google_btn: "Continua con Google",
    submit: "Invia", starting: "Avvio…",
    dashboard_hi: "Ciao",
    dashboard_stats: "Le tue statistiche",
    tab_tests: "Test disponibili", tab_history: "Storico tentativi", tab_purchases: "I miei acquisti",
    test_free_badge: "Gratuito",
    test_start: "Avvia test", test_unlock: "Sblocca",
    guides_locked: "Bloccata — sblocca per leggere",
    guides_read: "Leggi la guida",
    time_left: "Tempo rimasto",
    q_of: "Domanda", of: "di",
    submit_test: "Termina e correggi",
    skip: "Salta", prev: "Precedente", next: "Successiva",
    result_score: "Punteggio",
    result_review: "Revisione domande",
    correct: "Corretto", wrong: "Sbagliato",
    explanation: "Spiegazione",
    buy_now: "Acquista ora",
    checkout_loading: "Reindirizzamento a Stripe…",
    logout: "Esci",
    consent_required: "Devi accettare privacy e termini per continuare.",
  },
  en: {
    nav_home: "Home", nav_tests: "Tests", nav_guides: "Guides", nav_pricing: "Pricing",
    nav_dashboard: "Dashboard", nav_login: "Log in", nav_logout: "Log out",
    nav_register: "Sign up",
    hero_kicker: "EPSO 2026 — New format",
    hero_title: "Pass the EPSO test.",
    hero_title2: "With method. With rigor.",
    hero_sub: "Train on the three reasoning tests (verbal, abstract, numerical) with original questions and a free trial test available now. The premium guides teach you how to think — not how to guess.",
    hero_cta1: "Start free test",
    hero_cta2: "See pricing",
    hero_badge1: "Original questions",
    hero_badge2: "GDPR compliant",
    hero_badge3: "Freemium",
    how_kicker: "How it works",
    how_title: "Three steps. Zero wasted time.",
    how1_t: "Sign up and try free",
    how1_p: "A 6-question mixed test — see your level immediately.",
    how2_t: "Unlock premium packs",
    how2_p: "Per-category tests or the complete bundle.",
    how3_t: "Read the premium guides",
    how3_p: "Step-by-step method, protected and non-downloadable, for each test.",
    pricing_kicker: "Transparent pricing",
    pricing_title: "Pay only for what you need",
    pricing_sub: "No subscription. No surprises.",
    footer_note: "EU Logic Lab is not affiliated with EPSO or EU institutions. All questions are originally authored for training purposes.",
    cookie_msg: "We use essential technical cookies for the service and, with your consent, marketing/advertising cookies (Google Ads) to measure conversions. Read the",
    cookie_link: "cookie policy",
    cookie_accept: "Accept all",
    cookie_reject: "Essential only",
    accept_terms: "I accept the privacy policy and terms of service (required under GDPR)",
    email: "Email", password: "Password", name: "Name",
    login_title: "Log in to your account",
    register_title: "Create your account",
    already_have: "Already have an account?", need_account: "New here?",
    or_google: "or",
    google_btn: "Continue with Google",
    submit: "Submit", starting: "Starting…",
    dashboard_hi: "Hi",
    dashboard_stats: "Your stats",
    tab_tests: "Available tests", tab_history: "Attempts", tab_purchases: "My purchases",
    test_free_badge: "Free",
    test_start: "Start test", test_unlock: "Unlock",
    guides_locked: "Locked — unlock to read",
    guides_read: "Read guide",
    time_left: "Time left",
    q_of: "Question", of: "of",
    submit_test: "Finish and grade",
    skip: "Skip", prev: "Previous", next: "Next",
    result_score: "Score",
    result_review: "Question review",
    correct: "Correct", wrong: "Wrong",
    explanation: "Explanation",
    buy_now: "Buy now",
    checkout_loading: "Redirecting to Stripe…",
    logout: "Log out",
    consent_required: "You must accept privacy and terms to continue.",
  },
};

// Fallback for locales we advertise but haven't fully translated yet
["fr", "de", "es", "pl"].forEach(k => { dict[k] = dict.en; });

const LangContext = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("lang") || "it");
  const changeLang = (l) => { setLang(l); localStorage.setItem("lang", l); };
  const t = (k) => (dict[lang] && dict[lang][k]) || dict.it[k] || k;
  return <LangContext.Provider value={{ lang, setLang: changeLang, t }}>{children}</LangContext.Provider>;
}
export function useLang() { return useContext(LangContext); }
export const AVAILABLE_LANGS = [
  { code: "it", label: "IT" }, { code: "en", label: "EN" }, { code: "fr", label: "FR" },
  { code: "de", label: "DE" }, { code: "es", label: "ES" }, { code: "pl", label: "PL" },
];
